import { STAGE } from '@/env';

const ResponsiveHelper = () => {
  if (STAGE !== 'development') {
    return null;
  }

  return (
    <aside className="$tw-pointer-events-none $tw-fixed $tw-right-4 $tw-top-4 $tw-z-50 $tw-flex $tw-select-none $tw-gap-2 $tw-rounded $tw-border $tw-bg-background $tw-px-2 $tw-py-1 $tw-text-xs $tw-text-muted-foreground $tw-shadow-xl">
      <span className="$tw-opacity-25 xs:$tw-opacity-100">xs</span>
      <span className="$tw-opacity-25 sm:$tw-opacity-100">sm</span>
      <span className="$tw-opacity-25 md:$tw-opacity-100">md</span>
      <span className="$tw-opacity-25 lg:$tw-opacity-100">lg</span>
      <span className="$tw-opacity-25 xl:$tw-opacity-100">xl</span>
      <span className="$tw-opacity-25 2xl:$tw-opacity-100">2xl</span>
    </aside>
  );
};

export default ResponsiveHelper;
